<p-dialog header="Session Timeout" [(visible)]="visibleSessionTimerPopup" [modal]="true" [closable]="false"
  [style]="{ width: '500px' }" (onHide)="closePopup()">

  <!-- HEADER -->
  <ng-template pTemplate="header">
    <div class="header-container" [style.background-color]="headerBg">

      <!-- Close icon -->
      <img [src]="closeTimeoutIcon" class="close-icon" alt="Close" (click)="closePopup()" />

      <!-- Pill -->
      <div class="pill" [style.border-color]="pillStyles.borderColor" [style.color]="pillStyles.color">
        <img [src]="pillMiniIcon" class="mini-timer-icon" alt="Mini Icon" />
        <span>{{ pillStyles.text }}</span>
      </div>

      <!-- Main icon box -->
      <div class="timer-box">
        <img [src]="mainHeaderIcon" class="timer-icon" alt="State Icon" />
      </div>
    </div>
  </ng-template>

  <!-- Heading -->
  <h2 class="content-heading">
    {{ headingText }}
  </h2>

  <!-- IMPORTANT CARD -->
  <div class="important-card" [style.background-color]="importantCard.bgColor"
  [style.border]=" '1px solid ' + importantCard.borderColor ">

    <div class="card-header-row">
      <img [src]="importantIconState" class="important-icon" alt="Important" />
      <span class="card-title" [style.color]="importantCard.titleColor">
        IMPORTANT
      </span>
    </div>

    <div class="card-content">
      {{ importantCard.text }}
    </div>
  </div>

</p-dialog>